import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import { Icon20 } from 'builder/components/Icon'

export const List = styled.div`
  ${Typography.Caption};
  ${FontWeights.Regular};
  margin-top: ${Spacing.XS};
  display: flex;
  flex-direction: column;
  gap: ${Spacing['2XS']};
`

export const ListItem = styled.div`
  display: flex;
  gap: ${Spacing['3XS']};
  align-items: center;
`

export const ListIcon = styled(Icon20.Tick)`
  color: ${Colors.Green40};
`
